<mat-form-field class="w-100">

    <mat-label>{{ label }}</mat-label>
    <mat-select
        [formControl]="formCtrl"
        [matTooltip]="formCtrl.value"
        [multiple]="multiple"
        (openedChange)="onOpenedChange($event)"
        (selectionChange)="selectedValue($event.value)"
        data-testid="select"
    >
        @if (!options().length) {
            <app-loader [diameter]="50" [isLoading]="loading()" />
        }
        <mat-option>
            <ngx-mat-select-search
                [formControl]="searchControl"
                [noEntriesFoundLabel]="'Нет совпадений'"
                placeholderLabel="Поиск..."
                data-testid="search"
            ></ngx-mat-select-search>
        </mat-option>

        <cdk-virtual-scroll-viewport
            class="dropdown-viewport"
            itemSize="28"
            appendOnly
            (scrolledIndexChange)="onScroll($event)">
            @if (noneOption) {
                <mat-option [value]="null" (click)="selectedValue(null)"></mat-option>
            }

            <!-- Кнопка "Выбрать все" -->
            @if (selectAllButton && multiple && options().length) {
                <mat-option
                    (click)="toggleSelectAll()"
                    [value]="selectAllValue"
                    class="select-all-option"
                >
                    {{ selectedAll ? 'Снять выделение' : 'Выбрать все' }}
                </mat-option>
            }

            <mat-option
                class="option-viewport"
                *cdkVirtualFor="let option of options()"
                [value]="option.value"
                [matTooltip]="tooltipEnabled ? option.tooltip : ''"
                data-testid="option"
            >
                {{ option.label }}
            </mat-option>
        </cdk-virtual-scroll-viewport>
    </mat-select>
</mat-form-field>
